import { render, staticRenderFns } from "./StudioSettingsPage.vue?vue&type=template&id=6ccf5466&scoped=true"
import script from "./StudioSettingsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudioSettingsPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StudioSettingsPage.vue?vue&type=style&index=0&id=6ccf5466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf5466",
  null
  
)

export default component.exports